export default {
  isDeb: true,
  isDev: true,
}


// WEBPACK FOOTER //
// ./src/config/debug.js